import { render, staticRenderFns } from "./CompanyProfileWidget.vue?vue&type=template&id=1ab2c237&"
import script from "./CompanyProfileWidget.vue?vue&type=script&lang=js&"
export * from "./CompanyProfileWidget.vue?vue&type=script&lang=js&"
import style0 from "./CompanyProfileWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports